import React from "react";
import "./styles/Theme.css";

function Theme() {
  return (
    <div className="theme--container">
      <h6 className="theme--title">Theme/Eventi</h6>
      <div className="themes">
        <button>Opening</button>
        <button>Tithing</button>
        <button>Supper</button>
        <button>Christmas</button>
        <button>Easter</button>
      </div>
    </div>
  );
}

export default Theme;
